/**
 * Keeps a tenant's copyright notice current. Footer texts are tenant-authored and carry the
 * year they were written in ("© 2025 Myntra. All rights reserved."), so the year right after
 * ©, (c) or "Copyright" is moved up to the current one at render time: "© 2025" → "© 2026",
 * and a range keeps its start ("© 2019-2025" → "© 2019-2026"). The rest of the text, later
 * years, and text without a copyright mark are left as they are.
 */
const COPYRIGHT_YEAR = /((?:©|\(c\)|copyright)\s*)((?:19|20)\d{2})(?:(\s*[-–—]\s*)((?:19|20)\d{2}))?/gi;

export function withCurrentCopyrightYear(text: string, year: number = new Date().getFullYear()): string {
  if (!text) return text;
  return text.replace(COPYRIGHT_YEAR, (match, prefix: string, start: string, separator?: string, end?: string) => {
    if (separator && end) return Number(end) < year ? `${prefix}${start}${separator}${year}` : match;
    return Number(start) < year ? `${prefix}${year}` : match;
  });
}
